import React from "react";
import { Formik } from "formik";
import { useStudentFamilyBranch } from "./StudentFamilyBranchContext";
import * as Yup from "yup";

const searchSchema = Yup.object().shape({
  studentInfo: Yup.string()
    .trim()
    .required("Search input cannot be empty.")
    .test(
    "search-term-validation",
    "Invalid search term.", // Default message, will be overridden
    function(value) {
      // The .required() rule should handle empty values. This test should only run on non-empty values.
      // This guard prevents a TypeError if the value is undefined during validation.
      if (!value) {
        return true;
      }

      // Case 0: Email validation
      if (value.includes("@")) {
        try {
          Yup.string()
            .email("Please enter a valid email address.")
            .validateSync(value);
          return true;
        } catch (err) {
          return this.createError({ message: err.message });
        }
      }

      const hasLetters = /[a-zA-Z]/.test(value);
      const hasDigits = /\d/.test(value);

      // Case 1: Search term contains digits but no letters (ID or Phone search)
      if (hasDigits && !hasLetters) {
        const justDigits = value.replace(/\D/g, "");
        if (justDigits.length > 0 && justDigits.length < 4) {
          return this.createError({
            message: "Phone number or ID searches require at least 4 digits.",
          });
        }
        return true;
      }

      // Case 2: Search term contains letters (Name search, can include numbers)
      if (hasLetters) {
        if (value.trim().split(" ").filter(Boolean).length < 2) {
          return this.createError({
            message:
              "When searching by name, please provide at least a first name and the first letter of a last name.",
          });
        }
        return true;
      }

      // Fallback for any other cases (e.g. just symbols) - consider them valid
      return true;
    }
  ),
});

const StudentFamilyFilterSearch = () => {
  const { searchStudents } = useStudentFamilyBranch();

  return (
    <>
      <Formik
        initialValues={{ studentInfo: "" }}
        validationSchema={searchSchema}
        onSubmit={(values) => {
          searchStudents({ search: values.studentInfo });
        }}
      >
        {({ values, handleSubmit, setFieldValue, errors, touched }) => (
          <form onSubmit={handleSubmit} className="form form-label-right">
            <div className="form-group row">
              <div className="col-lg-4">
                <input
                  className={`form-control ${
                    touched.studentInfo && errors.studentInfo
                      ? "is-invalid"
                      : ""
                  }`}
                  placeholder="Student ID, Name, Parent, or Contact Information"
                  name="studentInfo"
                  onChange={(e) => {
                    setFieldValue("studentInfo", e.target.value);
                  }}
                  value={values.studentInfo}
                />
                {touched.studentInfo && errors.studentInfo ? (
                  <div className="invalid-feedback">
                    {errors.studentInfo}
                  </div>
                ) : (
                  <small className="form-text text-muted">
                    <b>Search</b> by Student Information
                  </small>
                )}
              </div>
              <div className="col-lg-2">
                <button type="submit" className="btn btn-primary">
                  Search
                </button>
              </div>
            </div>
          </form>
        )}
      </Formik>
    </>
  );
};

export default StudentFamilyFilterSearch;